import {put, select, take, takeEvery, takeLatest} from "redux-saga/effects";
import {
    CHANGE_ALLSTATIONS_RESERVATION_LOG,
    CHANGE_ALLSTATIONS_RESERVATION_LOG_START,
    CHANGE_ALLSTATIONS_VEHICLE_LOG,
    CHANGE_ALLSTATIONS_VEHICLE_LOG_START,
    CHANGE_DATES,
    CHANGE_DATES_START,
    CHANGE_DELIVERY_VEHICLE_LOG,
    CHANGE_DELIVERY_VEHICLE_LOG_START,
    CHANGE_FROMSTATION_VEHICLE_LOG,
    CHANGE_FROMSTATION_VEHICLE_LOG_START,
    CHANGE_PICKUPCONFIRMED_VEHICLE_LOG,
    CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START,
    CHANGE_PICKUPPLANNED_VEHICLE_LOG,
    CHANGE_PICKUPPLANNED_VEHICLE_LOG_START,
    CHANGE_SHOWAFTER_RESERVATION_LOG,
    CHANGE_SHOWAFTER_RESERVATION_LOG_START,
    CHANGE_SHOWAFTER_VEHICLE_LOG,
    CHANGE_SHOWAFTER_VEHICLE_LOG_START,
    CHANGE_SHOWBEFORE_RESERVATION_LOG,
    CHANGE_SHOWBEFORE_RESERVATION_LOG_START,
    CHANGE_SHOWBEFORE_VEHICLE_LOG,
    CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
    CHANGE_STATION,
    CHANGE_STATION_START,
    CHANGE_TOSTATION_VEHICLE_LOG,
    CHANGE_TOSTATION_VEHICLE_LOG_START,
    CHANGE_WITHOUTDELIVERED_VEHICLE_LOG,
    CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START,
    COMPILE_DISPOSITION_DATA,
    DISPO_SEARCH,
    DISPOSITION_INITIALIZE_SAGA,
    DISPOSITION_RESERVATION_LOG_FETCH_DATA,
    DISPOSITION_RESET_FILTER_SAGA,
    DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER,
    DISPOSITION_SET_DEFAULT_FILTER_SAGA,
    DISPOSITION_SET_DEFAULT_VALUES,
    DISPOSITION_SET_DEFAULT_VALUES_SAGA,
    DISPOSITION_SET_FILTER,
    DISPOSITION_UPDATE_AUTODISPO_STATUS_SAGA,
    DISPOSITION_VEHICLE_LOG_FETCH_DATA,
    FETCH_BOOKING,
    FETCH_BOOKING_SUCCESS,
    FETCHING_DATA_FAILED,
    FETCHING_DATA_START,
    FETCHING_RESERVATION_LOG_DATA_FAILED,
    FETCHING_RESERVATION_LOG_DATA_START,
    FETCHING_RESERVATION_LOG_DATA_SUCCESS,
    FETCHING_VEHICLE_LOG_DATA_START,
    FETCHING_VEHICLE_LOG_DATA_SUCCESS,
    INITIALIZE_SUCCESS,
    MOVE_BOOKING,
    RENDER,
    RESERVATION_LOG_INITIALIZE_SAGA,
    SET_SINGLE_DAY_PREVIOUS_STARTDATE,
    SET_SINGLE_DAY_PREVIOUS_STARTDATE_START,
    VEHICLE_LOG_INITIALIZE_SAGA
} from "@/Redux/Disposition/Constants";
import moment from "moment/moment";
import {fetchQuery, graphql} from "relay-runtime";
import {relayAuthEnvironment} from "@/RelayEnvironment";
import {cloneDeep} from "lodash";
import {USER_LOGOUT_EXPIRED} from "@/Redux/User/Constants";
import {Environment} from "react-relay";
import {selectCategories, selectRegions, selectStations, selectVehicleGroups,} from "@/Redux/App/AppReducer";
import {
    selectDispoDaysAfter,
    selectDispoDaysBefore,
    selectViewerDefaultRegion,
    selectViewerEnabledGroups,
    selectViewerEnabledStations,
} from "@/Redux/Auth/AuthReducer";
import {selectLastBookingContractColor, selectLastBookingHasVehicle} from "@/Redux/Disposition/DispositionReducer";

function* dispositionInitializeSaga(action: any) {
    yield put({type: DISPOSITION_SET_DEFAULT_FILTER_SAGA});

    yield take(DISPOSITION_SET_FILTER);

    yield put({
        type: DISPOSITION_SET_DEFAULT_VALUES_SAGA,
        payload: action.payload,
    });

    yield take(DISPOSITION_SET_DEFAULT_VALUES);

    yield put({type: INITIALIZE_SUCCESS});
}

function* vehicleLogInitializeSaga(action: any) {

    yield put({type: DISPOSITION_SET_DEFAULT_FILTER_SAGA});

    yield take(DISPOSITION_SET_FILTER);

    yield put({
        type: DISPOSITION_SET_DEFAULT_VALUES_SAGA,
        payload: action.payload
    });

    yield take(DISPOSITION_SET_DEFAULT_VALUES);

    yield put({type: INITIALIZE_SUCCESS})
}

function* reservationLogInitializeSaga(action: any) {
    yield put({type: DISPOSITION_SET_DEFAULT_FILTER_SAGA});

    yield take(DISPOSITION_SET_FILTER);

    yield put({
        type: DISPOSITION_SET_DEFAULT_VALUES_SAGA,
        payload: action.payload,
    });

    yield take(DISPOSITION_SET_DEFAULT_VALUES);

    yield put({type: INITIALIZE_SUCCESS});
}

function* dispositionSetDefaultFilterSaga(action: any) {
    //@ts-ignore
    const stations = yield select((state) => selectStations(state));
    //@ts-ignore
    const enabledStations = yield select((state) =>
        selectViewerEnabledStations(state),
    );
    //@ts-ignore
    const enabledGroups = yield select((state) =>
        selectViewerEnabledGroups(state),
    );
    //@ts-ignore
    const defaultRegion = yield select((state) =>
        selectViewerDefaultRegion(state),
    );
    //@ts-ignore
    const regions = yield select((state) => selectRegions(state));
    //@ts-ignore
    const vehicleGroups = yield select((state) => selectVehicleGroups(state));
    //@ts-ignore
    const categories = yield select((state) => selectCategories(state));

    let allStations = stations.data;

    const allStationsEnabledForViewer: any = [];
    for (const index in enabledStations) {
        allStationsEnabledForViewer.push(enabledStations[index].stationId);
    }

    allStations = allStations.filter(function (
        value: any,
        index: number,
        arr: any,
    ) {
        return allStationsEnabledForViewer.indexOf(value.stationId) > -1;
    });

    const allStationsForSelectedRegion: any = [];
    let regionIndex = "-1";
    for (const index in regions.data) {
        const region = regions.data[index];
        if (region.region === defaultRegion) {
            regionIndex = index;
        }
    }

    if (regionIndex !== "-1") {
        const enabledStationsInRegion =
            regions.data[regionIndex]?.enabledStations || [];
        for (const index in enabledStationsInRegion) {
            allStationsForSelectedRegion.push(
                enabledStationsInRegion[index].stationId,
            );
        }
    } else {
        for (const index in allStations) {
            allStationsForSelectedRegion.push(allStations[index].stationId);
        }
    }
    const stationIdsInDefaultRegion = allStations.filter(function (
        value: any,
        index: number,
        arr: any,
    ) {
        return (
            allStationsEnabledForViewer.indexOf(value.stationId) > -1 &&
            allStationsForSelectedRegion.indexOf(value.stationId) > -1
        );
    });
    const stationFilterDefault = [];
    for (const index in stationIdsInDefaultRegion) {
        stationFilterDefault.push(stationIdsInDefaultRegion[index].stationId);
    }

    let allGroups = vehicleGroups.data;

    const allGroupsEnabledForViewer: any = [];
    if (enabledGroups !== null) {
        for (const index in enabledGroups) {
            allGroupsEnabledForViewer.push(enabledGroups[index].vehicleGroupId);
        }

        allGroups = allGroups.filter(function (
            value: any,
            index: number,
            arr: any,
        ) {
            return allGroupsEnabledForViewer.indexOf(value.vehicleGroupId) > -1;
        });
    } else {
        for (const index in allGroups) {
            allGroupsEnabledForViewer.push(allGroups[index].vehicleGroupId);
        }
    }

    const categoryIndex = "-1";
    const allGroupsForSelectedCategory: any = [];
    if (categoryIndex !== "-1") {
        const enabledStationsInRegion =
            categories.data[categoryIndex]?.enabledVehicleGroups || [];
        for (const index in enabledStationsInRegion) {
            allGroupsForSelectedCategory.push(
                enabledStationsInRegion[index].vehicleGroupId,
            );
        }
    } else {
        for (const index in allGroups) {
            allGroupsForSelectedCategory.push(allGroups[index].vehicleGroupId);
        }
    }
    allGroups = allGroups.filter(function (
        value: any,
        index: number,
        arr: any,
    ) {
        return (
            allGroupsEnabledForViewer.indexOf(value.vehicleGroupId) > -1 &&
            allGroupsForSelectedCategory.indexOf(value.vehicleGroupId) > -1
        );
    });
    const filteredGroups = [];
    for (const index in allGroups) {
        filteredGroups.push(allGroups[index].vehicleGroupId);
    }
    yield put({
        type: DISPOSITION_SET_FILTER,
        data: {
            stationFilter: localStorage.getItem("CRENT_WEB/STATION_FILTER")
                ? JSON.parse(
                    localStorage.getItem(
                        "CRENT_WEB/STATION_FILTER",
                    ) as string,
                )
                : defaultRegion != null
                    ? stationFilterDefault
                    : [],
            vehicleGroupFilter:
                JSON.parse(
                    localStorage.getItem(
                        "CRENT_WEB/VEHICLE_GROUP_FILTER",
                    ) as string,
                ) || filteredGroups,
            regionFilter: localStorage.getItem("CRENT_WEB/REGION_FILTER")
                ? JSON.parse(
                    localStorage.getItem("CRENT_WEB/REGION_FILTER") as string,
                )
                : defaultRegion != null
                    ? [defaultRegion]
                    : [],
            categoryFilter:
                JSON.parse(
                    localStorage.getItem("CRENT_WEB/CATEGORY_FILTER") as string,
                ) || [],
            equipmentFilter:
                JSON.parse(
                    localStorage.getItem(
                        "CRENT_WEB/EQUIPMENT_FILTER",
                    ) as string,
                ) || [],
            showOnlyGroupResOfStationFilter:
                localStorage.getItem("CRENT_WEB/ONLY_GROUP_RES_OF_STATION") ||
                false,
        },
    });
}

function* dispositionSetDefaultValuesSaga(action: any) {
    // @ts-ignore
    const dispoDaysBefore = yield select((state) =>
        selectDispoDaysBefore(state),
    );
    // @ts-ignore
    const dispoDaysAfter = yield select((state) => selectDispoDaysAfter(state));

    const startdate = moment()
        .utc()
        .subtract(dispoDaysBefore, "days")
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0);
    const enddate = moment()
        .utc()
        .add(dispoDaysAfter + 1, "days")
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0);

    const days = enddate.diff(startdate, "days") + 1;
    const hours = 24;

    let dayWidth = 0;
    if (days === 1) {
        dayWidth = 100 / 24;
    } else {
        dayWidth = 100 / days;
    }

    yield put({
        type: DISPOSITION_SET_DEFAULT_VALUES,
        payload: {
            dispositionStartdate: startdate.format(),
            dispositionEnddate: enddate.format(),
            days,
            dayWidth: dayWidth,
            hours: hours,
            selectedStation:
                localStorage.getItem("CRENT_WEB/SELECTED_STATION") ||
                action.payload.selectedStation,
        },
    });
}

function* fetchDispoData(action: any) {
    // @ts-ignore
    const dispositionData: any = yield select((state) => state.disposition);

    try {
        // @ts-ignore
        const data: any = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query DispositionSagasDispositionQuery(
                    $selectedStation: String!
                    $dispoStartdate: String!
                    $dispoEnddate: String!
                    $additionalStations: String
                    $additionalGroups: String
                    $searchForVehicle: String
                    $searchForBooking: String
                    $filterEquipment: String
                    $filterRegion: String
                    $categoryFilter: String
                ) {
                    dispositionData(
                        selectedStation: $selectedStation
                        dispoStartdate: $dispoStartdate
                        dispoEnddate: $dispoEnddate
                        additionalStations: $additionalStations
                        additionalGroups: $additionalGroups
                        searchForBooking: $searchForBooking
                        searchForVehicle: $searchForVehicle
                        filterEquipment: $filterEquipment
                        filterRegion: $filterRegion
                        filterCategory: $categoryFilter
                    ) {
                        stations {
                            __typename
                            stationId
                            disponame
                            street
                            groupReservations {
                                __typename
                                bookingId
                                hasVehicle
                                startdate
                                enddate
                                plannedEnddate
                                vehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                plannedVehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                startstation
                                endstation
                                plannedEndstation
                                isDraggable
                                isSearchResult
                                isSearchResult
                                contractColor
                                isDraggable
                                frameColor
                                customer {
                                    customerId
                                    name1
                                }
                                reservationNumber
                                pickupDate
                                deliveryDate
                                driver1 {
                                    firstname
                                    lastname
                                }
                                vehicle
                                status
                                rate
                                divdata
                            }
                            vehicles {
                                stationArriving
                                __typename
                                vehicleId
                                name
                                licensePlate
                                mileage
                                maximumMileage
                                dispoColor
                                remark
                                remarkVehicle
                                vehicleGroup {
                                    vehicleGroupId
                                }
                                vehicleId
                                location {
                                    stationId
                                }
                                vehicleGroup {
                                    vehicleGroupId
                                }
                                equipment
                                wizStatus
                                wizTurnbackDate
                                reservations {
                                    __typename
                                    bookingId
                                    startdate
                                    enddate
                                    plannedEnddate
                                    isDraggable
                                    vehicle
                                    startstation
                                    endstation
                                    plannedEndstation
                                    isBilled
                                    vehicleGroup {
                                        vehicleGroupId
                                        description
                                    }
                                    contractColor
                                    frameColor
                                    hasVehicle
                                    customer {
                                        customerId
                                        name1
                                    }
                                    reservationNumber
                                    startstation
                                    endstation
                                    plannedEndstation
                                    startdate
                                    enddate
                                    plannedEnddate
                                    pickupDate
                                    deliveryDate
                                    status
                                    rate
                                    divdata
                                    isSearchResult
                                    delivered
                                    readyForPickup
                                    deliveryPrivate
                                    pickupPrivate
                                    hasInvoice
                                    wasReservation
                                    partialInvoiceDate
                                    plannedVehicleGroup {
                                        vehicleGroupId
                                        description
                                    }
                                    driver1 {
                                        firstname
                                        lastname
                                    }
                                }
                                availableUntil
                                availableFrom
                            }
                        }
                    }
                }
            `,
            {
                dispoStartdate: dispositionData.dispositionStartdate,
                dispoEnddate: dispositionData.dispositionEnddate,
                selectedStation: dispositionData.selectedStation,
                additionalStations: dispositionData.stationFilter.join(";"),
                additionalGroups: dispositionData.vehicleGroupFilter.join(";"),
                filterEquipment: dispositionData.equipmentFilter.join(";"),
                filterRegion: "",
                categoryFilter: "",
                searchForBooking: action?.payload?.searchForBooking || "",
                searchForVehicle: action?.payload?.searchForVehicle || "",
            },
        )
        .toPromise()
        .then((data) => {
            // throw Error('adasd');
            return data;
        })
        .catch((error) => {
            throw error;
        });

        yield put({
            type: COMPILE_DISPOSITION_DATA,
            data: data,
        });
    } catch (e: any) {
        if (e.status === 401) {
            yield put({type: USER_LOGOUT_EXPIRED});
        } else {
            yield put({type: FETCHING_DATA_FAILED});
        }
    }
}

function* fetchVehicleLogData(action: any) {

    // @ts-ignore
    const dispositionData: any = yield select(state => state.disposition);

    try {
        // @ts-ignore
        const data: any = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query DispositionSagasVehicleLogQuery($delivery: Boolean!, $pickupPlanned: Boolean!, $pickupConfirmed: Boolean!, $fromStation: Boolean!, $toStation: Boolean!, $startdate: String!, $enddate: String!, $station: String!, $region: String!, $allStations: Boolean!, $user: String!, $withoutDelivered: Boolean) {
                    vehicleLogList(delivery: $delivery, pickupPlanned: $pickupPlanned, pickupConfirmed: $pickupConfirmed, fromStation: $fromStation, toStation: $toStation, startdate: $startdate, enddate: $enddate, station: $station, region: $region, allStations: $allStations, user: $user, withoutDelivered: $withoutDelivered ) {
                        vehicleLogs {
                            status
                            bookingId
                            vehicleId
                            licensePlate
                            vehicleName
                            stationId
                            mileage
                            mileageTarget
                            startdate
                            enddate
                            vehicleGroup
                            remark
                            userRemark
                            parkingArea
                            equipment
                            maxKm
                            buybackAgreement
                            position
                            owner
                            date
                            type
                            customerName
                            customerStreet
                            customerZipcode
                            customerCity
                            remark1
                            remark2
                            customerId
                            agentName
                            agentStreet
                            agentCity
                            agentZipcode
                            isRentable
                            disponame
                            vehicleStatus
                            hasLetter
                            vehicleDelivered
                            licenseOrdered
                            orderId
                            lastTenant
                            workshopVehicle
                            workshopVehicleFrom
                            workshopVehicleTo
                            deliveryName1
                            deliveryName2
                            deliveryStreet
                            deliveryZipcode
                            deliveryCity
                            deliveryPhone
                            deliveryDate
                            pickupName1
                            pickupName2
                            pickupStreet
                            pickupZipcode
                            pickupCity
                            pickupPhone
                            pickupDate
                            alternateGroups
                            color
                            availableUntil
                            unladenWeight
                            totalWeight
                            insideHeight
                            insideWidth
                            insideLength
                            wizMaxKm
                            reservationStartdate
                            reservationEnddate
                            reservationPlannedEnddate
                            contractColor
                            dispoColor
                            driver1 {
                                firstname
                                lastname
                            }
                            customer {
                                customerId
                                name1
                            }
                            plannedVehicleGroup {
                                vehicleGroupId
                                description
                            }
                            reservationNumber
                            rate
                            tripsBefore {
                                bookingId
                                startdate
                                enddate
                                plannedEnddate
                                vehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                plannedVehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                startstation {
                                    stationId
                                }
                                endstation {
                                    stationId
                                }
                                plannedEndstation {
                                    stationId
                                }
                                isSearchResult
                                isSearchResult
                                contractColor
                                frameColor
                                customer {
                                    customerId
                                    name1
                                }
                                reservationNumber
                                pickupDate
                                deliveryDate
                                driver1 {
                                    firstname
                                    lastname
                                }

                                rate
                            }
                            tripsAfter {
                                bookingId
                                startdate
                                enddate
                                plannedEnddate
                                vehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                plannedVehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                startstation {
                                    stationId
                                }
                                endstation {
                                    stationId
                                }
                                plannedEndstation {
                                    stationId
                                }
                                isSearchResult
                                isSearchResult
                                contractColor
                                frameColor
                                customer {
                                    customerId
                                    name1
                                }
                                reservationNumber
                                pickupDate
                                deliveryDate
                                driver1 {
                                    firstname
                                    lastname
                                }

                                rate
                            }
                        }
                    }
                }
            `,
            {
                delivery: dispositionData.delivery,
                pickupPlanned: dispositionData.pickupPlanned,
                pickupConfirmed: dispositionData.pickupConfirmed,
                fromStation: dispositionData.fromStation,
                toStation: dispositionData.toStation,
                startdate: dispositionData.dispositionStartdate,
                enddate: dispositionData.dispositionEnddate,
                station: dispositionData.selectedStation,
                region: '',
                allStations: dispositionData.allStations,
                user: action.payload.user,
                withoutDelivered: dispositionData.withoutDelivered,
            }
        ).toPromise().then(data => {
            // throw Error('adasd');
            return data
        }).catch(error => {
            throw error;
        });
        yield put({
            type: FETCHING_VEHICLE_LOG_DATA_SUCCESS,
            payload: data
        })
    } catch (e: any) {
        if (e.status === 401) {
            yield put({type: USER_LOGOUT_EXPIRED});
        } else {
            yield put({type: FETCHING_DATA_FAILED});

        }
    }
}

function* fetchReservationLogData(action: any) {
    // @ts-ignore
    const dispositionData: any = yield select((state) => state.disposition);

    try {
        // @ts-ignore
        const data: any = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query DispositionSagasReservationLogQuery(
                    $from: String!
                    $to: String!
                    $station: String!
                    $before: Boolean
                    $after: Boolean
                    $wizardOnly: Boolean
                ) {
                    reservationLogList(
                        from: $from
                        to: $to
                        station: $station
                        before: $before
                        after: $after
                        wizardOnly: $wizardOnly
                    ) {
                        reservationLogs {
                            bookingId
                            vehicleId
                            licensePlate
                            vehicleName
                            stationId
                            mileage
                            mileageTarget
                            startdate
                            enddate
                            vehicleGroup
                            remark
                            userRemark
                            parkingArea
                            equipment
                            maxKm
                            buybackAgreement
                            position
                            owner
                            date
                            type
                            customerName
                            customerStreet
                            customerZipcode
                            customerCity
                            remark1
                            remark2
                            customerId
                            agentName
                            agentStreet
                            agentCity
                            agentZipcode
                            isRentable
                            disponame
                            vehicleStatus
                            hasLetter
                            vehicleDelivered
                            licenseOrdered
                            orderId
                            lastTenant
                            workshopVehicle
                            workshopVehicleFrom
                            workshopVehicleTo
                            deliveryName1
                            deliveryName2
                            deliveryStreet
                            deliveryZipcode
                            deliveryCity
                            deliveryPhone
                            deliveryDate
                            pickupName1
                            pickupName2
                            pickupStreet
                            pickupZipcode
                            pickupCity
                            pickupPhone
                            pickupDate
                            alternateGroups
                            color
                            availableFrom
                            availableUntil
                            unladenWeight
                            totalWeight
                            insideHeight
                            insideWidth
                            insideLength
                            wizMaxKm
                            reservationStartdate
                            reservationEnddate
                            reservationPlannedEnddate
                            contractColor
                            dispoColor
                            hasVehicle
                            driver1 {
                                firstname
                                lastname
                            }
                            customer {
                                customerId
                                name1
                            }
                            plannedVehicleGroup {
                                vehicleGroupId
                                description
                            }
                            reservationNumber
                            rate
                            mustBe
                            vehicleIsFixed
                            status
                            vehicle {
                                vehicleId
                                location {
                                    stationId
                                }
                            }
                            startstation {
                                stationId
                            }
                            tripsBefore {
                                bookingId
                                startdate
                                enddate
                                plannedEnddate
                                vehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                plannedVehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                startstation {
                                    stationId
                                }
                                endstation {
                                    stationId
                                }
                                plannedEndstation {
                                    stationId
                                }
                                isSearchResult
                                isSearchResult
                                contractColor
                                frameColor
                                customer {
                                    customerId
                                    name1
                                }
                                reservationNumber
                                pickupDate
                                deliveryDate
                                driver1 {
                                    firstname
                                    lastname
                                }

                                rate
                                mustBe
                                status
                                vehicle {
                                    vehicleId
                                    location {
                                        stationId
                                    }
                                }
                            }
                            tripsAfter {
                                bookingId
                                startdate
                                enddate
                                plannedEnddate
                                vehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                plannedVehicleGroup {
                                    vehicleGroupId
                                    description
                                }
                                startstation {
                                    stationId
                                }
                                endstation {
                                    stationId
                                }
                                plannedEndstation {
                                    stationId
                                }
                                isSearchResult
                                isSearchResult
                                contractColor
                                frameColor
                                customer {
                                    customerId
                                    name1
                                }
                                reservationNumber
                                pickupDate
                                deliveryDate
                                driver1 {
                                    firstname
                                    lastname
                                }

                                rate
                                mustBe
                                vehicleIsFixed
                                status
                                vehicle {
                                    vehicleId
                                    location {
                                        stationId
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            {
                from: dispositionData.dispositionStartdate,
                to: dispositionData.dispositionEnddate,
                station: dispositionData.allStations
                    ? "%"
                    : dispositionData.selectedStation,
                before: dispositionData.showBefore,
                after: dispositionData.showAfter,
                wizardOnly: false,
            },
        )
        .toPromise()
        .then((data) => {
            // throw Error('adasd');
            return data;
        })
        .catch((error) => {
            throw error;
        });
        yield put({
            type: FETCHING_RESERVATION_LOG_DATA_SUCCESS,
            payload: data,
        });
    } catch (e: any) {
        if (e.status === 401) {
            yield put({type: USER_LOGOUT_EXPIRED});
        } else {
            yield put({type: FETCHING_RESERVATION_LOG_DATA_FAILED});
        }
    }
}

function* changeStation(action: any) {
    yield put({type: CHANGE_STATION, data: action.payload});
}

function* search(action: any) {
    // @ts-ignore
    const dispositionData: any = yield select((state) => state.disposition);
    yield put({
        type: FETCHING_DATA_START,
        payload: {
            ...dispositionData,
            ...action.payload,
        },
    });
}

function* moveBooking(action: any) {
    // @ts-ignore
    const disposition: any = yield select((state) => state.disposition);
    const dispoList = cloneDeep(disposition.rawData);
    const bookingId = action.payload.bookingId;
    const vehicleId = action.payload.vehicleId;
    const stationId = action.payload.stationId;

    let reservation;
    for (const stationKey in dispoList.dispositionData.stations) {
        // find and remove reservation in stations group reservations
        for (const groupReservationKey in dispoList.dispositionData.stations[
            stationKey
            ].groupReservations) {
            if (
                dispoList.dispositionData.stations[stationKey]
                    .groupReservations[groupReservationKey].bookingId ===
                bookingId
            ) {
                reservation =
                    dispoList.dispositionData.stations[stationKey]
                        .groupReservations[groupReservationKey];
                dispoList.dispositionData.stations[
                    stationKey
                    ].groupReservations.splice(groupReservationKey, 1);
                break;
            }
        }

        for (const vehicleKey in dispoList.dispositionData.stations[stationKey]
            .vehicles) {
            // find and remove old reservation in stations vehicle reservations
            for (const bookingKey in dispoList.dispositionData.stations[
                stationKey
                ].vehicles[vehicleKey].reservations) {
                if (
                    dispoList.dispositionData.stations[stationKey].vehicles[
                        vehicleKey
                        ].reservations[bookingKey].bookingId === bookingId
                ) {
                    reservation =
                        dispoList.dispositionData.stations[stationKey].vehicles[
                            vehicleKey
                            ].reservations[bookingKey];
                    dispoList.dispositionData.stations[stationKey].vehicles[
                        vehicleKey
                        ].reservations.splice(bookingKey, 1);
                    break;
                }
            }
        }
    }

    for (const stationKey in dispoList.dispositionData.stations) {
        // add reservation to new vehicle
        if (vehicleId !== null) {
            for (const vehicleKey in dispoList.dispositionData.stations[
                stationKey
                ].vehicles) {
                if (
                    dispoList.dispositionData.stations[stationKey].vehicles[
                        vehicleKey
                        ].vehicleId === vehicleId
                ) {
                    if (!reservation.vehicle) {
                        reservation.vehicle = {};
                    }

                    yield put({
                        type: FETCH_BOOKING,
                        data: reservation.bookingId,
                    });

                    yield take(FETCH_BOOKING_SUCCESS);

                    const contractColor: any = yield select((state) => selectLastBookingContractColor(state));
                    const hasVehicle: any = yield select((state) => selectLastBookingHasVehicle(state));

                    reservation.contractColor = contractColor;
                    reservation.hasVehicle = hasVehicle;
                    reservation.vehicle = vehicleId;
                    dispoList.dispositionData.stations[stationKey].vehicles[
                        vehicleKey
                        ].reservations.push(reservation);
                    //dispoList.dispositionData.stations[stationKey].vehicles[vehicleKey].reservations.push(reservation)
                    break;
                }
            }
        } else {
            if (
                dispoList.dispositionData.stations[stationKey].stationId ===
                stationId
            ) {
                if (reservation.vehicle) {
                    reservation.vehicle = null;
                }

                dispoList.dispositionData.stations[
                    stationKey
                    ].groupReservations.push(reservation);

                yield put({
                    type: FETCH_BOOKING,
                    data: reservation.bookingId,
                });

                yield take(FETCH_BOOKING_SUCCESS);

                const contractColor: any = yield select((state) => selectLastBookingContractColor(state));
                const hasVehicle: any = yield select((state) => selectLastBookingHasVehicle(state));

                reservation.contractColor = contractColor;
                reservation.hasVehicle = hasVehicle;

                //dispoList.dispositionData.stations[stationKey].vehicles[vehicleKey].reservations.push(reservation)
                break;
            }
        }
    }

    yield put({
        type: COMPILE_DISPOSITION_DATA,
        data: dispoList,
    });

    yield put({
        type: FETCH_BOOKING,
        data: reservation.bookingId,
    });

    yield take(FETCH_BOOKING_SUCCESS);

    const contractColor: any = yield select((state) => selectLastBookingContractColor(state));
    const hasVehicle: any = yield select((state) => selectLastBookingHasVehicle(state));

    reservation.contractColor = contractColor;
    reservation.hasVehicle = hasVehicle;
}

function* compileDispositionData(action: any) {
    const dispoList = [];
    let index = 0;
    const data = action.data;

    if (data?.dispositionData === null) {
        return;
    }

    const arrivingVehicles = [];
    // @ts-ignore
    const dispositionData: any = yield select((state) => state.disposition);

    for (const stationKey in data.dispositionData.stations) {
        index++;
        for (const vehicleKey in data.dispositionData.stations[stationKey]
            .vehicles) {
            let indexReservation = 0;
            if (
                data.dispositionData.stations[stationKey].vehicles[vehicleKey]
                    .stationArriving === dispositionData.selectedStation
            ) {
                arrivingVehicles.push(
                    data.dispositionData.stations[stationKey].vehicles[
                        vehicleKey
                        ],
                );
                for (const reservationKey in data.dispositionData.stations[
                    stationKey
                    ].vehicles[vehicleKey].reservations) {
                    const reservation = {
                        ...data.dispositionData.stations[stationKey].vehicles[
                            vehicleKey
                            ].reservations[reservationKey],
                        listItemIndex: index,
                    };
                    arrivingVehicles.push(reservation);
                    indexReservation++;
                }
            }
        }
    }

    for (const stationKey in data.dispositionData.stations) {
        dispoList.push(data.dispositionData.stations[stationKey]);
        index++;
        for (const groupReservationKey in data.dispositionData.stations[
            stationKey
            ].groupReservations) {
            dispoList.push({
                __typename: "GroupReservation",
                startstation:
                data.dispositionData.stations[stationKey].groupReservations[
                    groupReservationKey
                    ].startstation,
                vehicleGroup:
                data.dispositionData.stations[stationKey].groupReservations[
                    groupReservationKey
                    ].vehicleGroup,
                reservations: [
                    data.dispositionData.stations[stationKey].groupReservations[
                        groupReservationKey
                        ],
                ],
            });

            index = index + 2;
        }

        for (const vehicleKey in data.dispositionData.stations[stationKey]
            .vehicles) {
            dispoList.push(
                data.dispositionData.stations[stationKey].vehicles[vehicleKey],
            );
            let indexReservation = 0;
            for (const reservationKey in data.dispositionData.stations[
                stationKey
                ].vehicles[vehicleKey].reservations) {
                const reservation = {
                    ...data.dispositionData.stations[stationKey].vehicles[
                        vehicleKey
                        ].reservations[reservationKey],
                    listItemIndex: index,
                };
                dispoList.push(reservation);
                indexReservation++;
            }
            index = index + 1 + indexReservation;
        }

        if (
            data.dispositionData.stations[stationKey].stationId ===
            dispositionData.selectedStation &&
            dispositionData.showArrivingVehicles
        ) {
            dispoList.push({
                __typename: "ArrivingVehicles",
                //arrivingVehicles: arrivingVehicles
            });
            for (const key in arrivingVehicles) {
                dispoList.push({...arrivingVehicles[key], isArriving: true});
            }
        }
    }

    yield put({
        type: RENDER,
        data: dispoList,
    });
}

function* changeDelivery(action: any) {
    yield put({
        type: CHANGE_DELIVERY_VEHICLE_LOG,
        data: {
            delivery: action.payload.delivery
        }
    })
}

function* setSingleDayPreviousStartdate(action: any) {
    yield put({
        type: SET_SINGLE_DAY_PREVIOUS_STARTDATE,
        data: {
            singleDayPreviousStartdate: action.payload.singleDayPreviousStartdate
        }
    })
}

function* showAfter(action: any) {
    yield put({
        type: CHANGE_SHOWAFTER_VEHICLE_LOG,
        data: {
            showAfter: action.payload.showAfter
        }
    })
}

function* showBefore(action: any) {
    yield put({
        type: CHANGE_SHOWBEFORE_VEHICLE_LOG,
        data: {
            showBefore: action.payload.showBefore
        }
    })
}

function* allStations(action: any) {
    yield put({
        type: CHANGE_ALLSTATIONS_VEHICLE_LOG,
        data: {
            allStations: action.payload.allStations
        }
    })
}

function* changePickupplanned(action: any) {
    yield put({
        type: CHANGE_PICKUPPLANNED_VEHICLE_LOG,
        data: {
            pickupPlanned: action.payload.pickupPlanned
        }
    })
}

function* changePickupConfirmed(action: any) {
    yield put({
        type: CHANGE_PICKUPCONFIRMED_VEHICLE_LOG,
        data: {
            pickupConfirmed: action.payload.pickupConfirmed
        }
    })
}

function* changeFromStation(action: any) {
    yield put({
        type: CHANGE_FROMSTATION_VEHICLE_LOG,
        data: {
            fromStation: action.payload.fromStation
        }
    })
}

function* changeToStation(action: any) {
    yield put({
        type: CHANGE_TOSTATION_VEHICLE_LOG,
        data: {
            toStation: action.payload.toStation
        }
    })
}

function* changeWithoutDelivered(action: any) {
    yield put({
        type: CHANGE_WITHOUTDELIVERED_VEHICLE_LOG,
        data: {
            withoutDelivered: action.payload.withoutDelivered
        }
    })
}

function* changeAllStations(action: any) {
    yield put({
        type: CHANGE_ALLSTATIONS_RESERVATION_LOG,
        data: {
            allStations: action.payload.allStations,
        },
    });
}

function* changeShowBefore(action: any) {
    yield put({
        type: CHANGE_SHOWBEFORE_RESERVATION_LOG,
        data: {
            showBefore: action.payload.showBefore,
        },
    });
}

function* changeShowAfter(action: any) {
    yield put({
        type: CHANGE_SHOWAFTER_RESERVATION_LOG,
        data: {
            showAfter: action.payload.showAfter,
        },
    });
}

function* fetchBooking(action: any) {
    try {
        // @ts-ignore
        const data: any = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query DispositionSagasRefetchBookingQuery(
                    $id: String!
                ) {
                    booking(id: $id) {
                        bookingId
                        contractColor
                        hasVehicle
                    }
                }
            `,
            {
                id: action.data,
            },
        )
        .toPromise()
        .then((data) => {
            // throw Error('adasd');
            return data;
        })
        .catch((error) => {
            throw error;
        });

        yield put({
            type: FETCH_BOOKING_SUCCESS,
            data: [data.booking?.contractColor, data.booking?.hasVehicle],
        });
    } catch (e: any) {
        yield put({
            type: FETCH_BOOKING_SUCCESS,
            data: null,
        });
    }
}

function* changeDates(action: any) {
    // @ts-ignore
    const dispositionData: any = yield select((state) => state.disposition);

    const dispositionStartdate = moment.utc(
        action.payload.dispositionStartdate,
    );
    const dispositionEnddate = moment.utc(action.payload.dispositionEnddate);

    const latestFetchedStartdate = moment.utc(
        dispositionData.latestFetchedStartdate,
    );
    const latestFetchedEnddate = moment.utc(
        dispositionData.latestFetchedEnddate,
    );

    const days = dispositionEnddate.diff(dispositionStartdate, "days") + 1;
    const hours = 24;

    let dayWidth = 0;
    let singleDay = 1;
    if (days === 1) {
        dayWidth = 100 / 24;
        singleDay = 24;
    } else {
        dayWidth = 100 / days;
    }

    yield put({
        type: CHANGE_DATES,
        data: {
            dispositionStartdate: dispositionStartdate
                .hours(0)
                .minutes(0)
                .seconds(0)
                .format(),
            dispositionEnddate: dispositionEnddate
                .hours(0)
                .minutes(0)
                .seconds(0)
                .add(1, "days")
                .format(),
            hours,
            dayWidth,
            days,
            singleDay,
        },
    });

    if (
        dispositionStartdate.isBetween(
            latestFetchedStartdate,
            latestFetchedEnddate,
            null,
            "[]",
        ) &&
        dispositionEnddate.isBetween(
            latestFetchedStartdate,
            latestFetchedEnddate,
            null,
            "[]",
        ) &&
        dispositionData.rawData !== null
    ) {
        yield put({
            type: COMPILE_DISPOSITION_DATA,
            data: dispositionData.rawData,
        });
    } else {
        yield put({
            type: FETCHING_DATA_START,
            payload: {
                dispositionStartdate: dispositionStartdate.format(),
                dispositionEnddate: dispositionEnddate.format(),
            },
        });
    }
}

function* dispositionResetFilterSaga(action: any) {
    localStorage.removeItem("CRENT_WEB/SELECTED_STATION");
    localStorage.removeItem("CRENT_WEB/STATION_FILTER");
    localStorage.removeItem("CRENT_WEB/VEHICLE_GROUP_FILTER");
    localStorage.removeItem("CRENT_WEB/REGION_FILTER");
    localStorage.removeItem("CRENT_WEB/CATEGORY_FILTER");
    localStorage.removeItem("CRENT_WEB/EQUIPMENT_FILTER");

    yield put({type: DISPOSITION_SET_DEFAULT_FILTER_SAGA});
    yield put({
        type: DISPOSITION_SET_DEFAULT_VALUES_SAGA,
        payload: {selectedStation: action.payload.selectedStation},
    });
}

function* updateAutoDispoStatus(action: any) {
    const {callback} = action.payload;
    try {
        // @ts-ignore
        const data: any = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query DispositionSagasUpdateAutoDispoStatusQuery(
                    $stationId: String!
                ) {
                    autoDispo(stationId: $stationId) {
                        isDeactivated
                    }
                }
            `,
            {
                stationId: action.payload.stationId,
            },
        )
        .toPromise()
        .then((data) => {
            // throw Error('adasd');
            return data;
        })
        .catch((error) => {
            throw error;
        });

        callback(data.autoDispo?.isDeactivated, null);
    } catch (e: any) {
        callback(false, e);
    }
}

function* resetShowOnlyGroupResOfStationFilter(action: any) {
    localStorage.removeItem("CRENT_WEB/ONLY_GROUP_RES_OF_STATION");
}

function* dispositionSagas() {
    yield takeLatest(DISPOSITION_INITIALIZE_SAGA, dispositionInitializeSaga);
    yield takeEvery(
        DISPOSITION_SET_DEFAULT_FILTER_SAGA,
        dispositionSetDefaultFilterSaga,
    );
    yield takeEvery(
        DISPOSITION_SET_DEFAULT_VALUES_SAGA,
        dispositionSetDefaultValuesSaga,
    );
    yield takeLatest(FETCHING_DATA_START, fetchDispoData);
    yield takeLatest(CHANGE_STATION_START, changeStation);
    yield takeLatest(CHANGE_DATES_START, changeDates);
    yield takeLatest(MOVE_BOOKING, moveBooking);
    yield takeLatest(FETCH_BOOKING, fetchBooking);
    yield takeLatest(COMPILE_DISPOSITION_DATA, compileDispositionData);
    yield takeLatest(DISPO_SEARCH, search);
    yield takeEvery(DISPOSITION_RESET_FILTER_SAGA, dispositionResetFilterSaga);
    yield takeEvery(
        DISPOSITION_UPDATE_AUTODISPO_STATUS_SAGA,
        updateAutoDispoStatus,
    );
    yield takeLatest(
        DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER,
        resetShowOnlyGroupResOfStationFilter,
    );
    yield takeLatest(
        RESERVATION_LOG_INITIALIZE_SAGA,
        reservationLogInitializeSaga,
    );
    yield takeLatest(
        FETCHING_RESERVATION_LOG_DATA_START,
        fetchReservationLogData,
    );
    yield takeLatest(
        CHANGE_ALLSTATIONS_RESERVATION_LOG_START,
        changeAllStations,
    );
    yield takeLatest(CHANGE_SHOWBEFORE_RESERVATION_LOG_START, changeShowBefore);
    yield takeLatest(CHANGE_SHOWAFTER_RESERVATION_LOG_START, changeShowAfter);
    yield takeLatest(
        DISPOSITION_RESERVATION_LOG_FETCH_DATA,
        fetchReservationLogData,
    );
    yield takeLatest(
        DISPOSITION_VEHICLE_LOG_FETCH_DATA,
        fetchVehicleLogData
    );
    yield takeLatest(
        CHANGE_DELIVERY_VEHICLE_LOG_START,
        changeDelivery
    );
    yield takeLatest(
        SET_SINGLE_DAY_PREVIOUS_STARTDATE_START,
        setSingleDayPreviousStartdate
    );
    yield takeLatest(
        CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START,
        changePickupConfirmed
    );
    yield takeLatest(
        CHANGE_FROMSTATION_VEHICLE_LOG_START,
        changeFromStation
    );
    yield takeLatest(
        CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START,
        changeWithoutDelivered
    );
    yield takeLatest(
        CHANGE_PICKUPPLANNED_VEHICLE_LOG_START,
        changePickupplanned
    );
    yield takeLatest(
        CHANGE_TOSTATION_VEHICLE_LOG_START,
        changeToStation
    );
    yield takeLatest(
        CHANGE_SHOWAFTER_VEHICLE_LOG_START,
        showAfter
    );
    yield takeLatest(
        CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
        showBefore
    );
    yield takeLatest(
        CHANGE_ALLSTATIONS_VEHICLE_LOG_START,
        allStations
    );
    yield takeLatest(
        VEHICLE_LOG_INITIALIZE_SAGA,
        vehicleLogInitializeSaga
    );
    yield takeLatest(
        FETCHING_VEHICLE_LOG_DATA_START,
        fetchVehicleLogData
    );
}

export default dispositionSagas;